module.exports = {
  windowEvents: {
    authWidgetClosed: "authWidgetClosed",
    inboxMounted: "inboxMounted",
    loggedIn: "loggedIn",
  },
};
